{
  "showMore": { "whenCollapsed": "Mehr anzeigen", "whenExpanded": "Weniger anzeigen" }
}
